import WafBlockedContent from '@/components/WafBlockedContent/WafBlockedContent';
import { useTranslation } from 'react-i18next';

const WafBlocked = () => {
  const { t } = useTranslation();

  return (
    <div className='not-found h-full'>
      <WafBlockedContent
        error={t('error.wafBlocked.eyebrow')}
        title={t('error.wafBlocked.title')}
        description={t('error.wafBlocked.description')}
        buttonText={t('homepage')}
      />
    </div>
  );
};

export default WafBlocked;
